import axios from '../axios';
// 车辆表列表
export const getBaseCarPage = data => {
    return axios({
        url: '/api/sys/getBaseCarPage',
        method: 'post',
        data
    })
};
// 车辆表列表保存
export const saveBaseCar = data => {
  return axios({
      url: '/api/sys/saveBaseCar',
      method: 'post',
      data
  })
};
// 车辆表列表修改
export const updateBaseCar = data => {
  return axios({
      url: '/api/sys/updateBaseCar',
      method: 'post',
      data
  })
};
// 车辆表列表删除
export const deleteBaseCars = data => {
  return axios({
      url: '/api/sys/deleteBaseCars',
      method: 'post',
      data
  })
};
// 启用车辆状态
export const enableBaseCar = data => {
  return axios({
      url: '/api/sys/enableBaseCar',
      method: 'post',
      data
  })
};
// 停用车辆状态
export const forbidBaseCar = data => {
  return axios({
      url: '/api/sys/forbidBaseCar',
      method: 'post',
      data
  })
};


// 车运记录表列表
export const getMeterWayCarPage = data => {
  return axios({
      url: '/api/sys/meter/meterWayCar/getMeterWayCarPage',
      method: 'post',
      data
  })
};
// 车运记录表列表 作废
export const cancel = data => {
  return axios({
      url: '/api/sys/meter/meterWayCar/cancelMeterWayCar',
      method: 'post',
      data
  })
};
// 车运记录表列表 查询明细
export const getMeterWayCarDetailPage = data => {
  return axios({
      url: '/api/sys/meter/meterWayCar/getMeterWayCarDetailPage',
      method: 'post',
      data
  })
};
// 车运记录表列表 查询明细（返回了是否已装货标识）
export const getMeterWayCarDetailLoad = data => {
  return axios({
      url: '/api/sys/meter/meterWayCar/getMeterWayCarDetailLoad',
      method: 'post',
      data
  })
};
// 提交离厂申请
export const submitLeaveRequest = data => {
  return axios({
      url: '/api/sys/meter/meterWayCar/submitLeaveRequest',
      method: 'post',
      data
  })
};
// 离厂申请审批
export const auditLeaveRequest = data => {
  return axios({
      url: '/api/sys/meter/meterWayCar/auditLeaveRequest',
      method: 'post',
      data
  })
};
// 车运记录表列表 保存一次重
export const oneWeight = data => {
  return axios({
      url: '/api/sys/pur/arrival/oneWeight',
      method: 'post',
      data
  })
};
// 车运记录表列表 保存二次重
export const twoWeight = data => {
  return axios({
      url: '/api/sys/pur/arrival/twoWeight',
      method: 'post',
      data
  })
};
// 车运记录表列表 新增车运销货单/进货单
export const saveMeterWayCar = data => {
  return axios({
      url: '/api/sys/meter/meterWayCar/saveMeterWayCar',
      method: 'post',
      data
  })
};
// 车运记录表列表 修改车运记录表
export const updateMeterWayCar = data => {
  return axios({
      url: '/api/sys/meter/meterWayCar/updateMeterWayCar',
      method: 'post',
      data
  })
};
// 车运记录表列表 修改对方磅重
export const updateOtherWeight = data => {
  return axios({
      url: '/api/sys/meter/meterWayCar/updateOtherWeight',
      method: 'post',
      data
  })
};
// 车运记录表列表 新增车运销货单/进货单
export const updateWeight = data => {
  return axios({
      url: '/api/sys/meter/meterWayCar/updateWeight',
      method: 'post',
      data
  })
};
// 司机列表
export const getBaseDriverPage = data => {
  return axios({
      url: '/api/sys/base/getBaseDriverPage',
      method: 'post',
      data
  })
};
// 司机列表 保存
export const saveBaseDriver = data => {
  return axios({
      url: '/api/sys/base/saveBaseDriver',
      method: 'post',
      data
  })
};
// 司机列表 修改
export const updateBaseDriver = data => {
  return axios({
      url: '/api/sys/base/updateBaseDriver',
      method: 'post',
      data
  })
};
// 司机列表 删除
export const deleteBaseDrivers = data => {
  return axios({
      url: '/api/sys/base/deleteBaseDrivers',
      method: 'post',
      data
  })
};
// 7.地磅设备查询
// export const getMeterLoadometerPage = data => {
//   return axios({
//       url: '/api/sys/meter/loadometer/getMeterLoadometerPage',
//       method: 'post',
//       data
//   })
// };
// 修改地磅设备维护 网页
export const updateMeterLoadometer = data => {
  return axios({
      url: '/api/sys/meter/loadometer/updateMeterLoadometer',
      method: 'post',
      data
  })
};
// 7.二次过磅
export const saveSecondWeightManual = data => {
  return axios({
      url: '/api/sys/meter/weight/saveSecondWeightManual',
      method: 'post',
      data
  })
};
// 查询单条称重表
export const getMeterWeight = data => {
  return axios({
      url: '/api/sys/meter/weight/getMeterWeight',
      method: 'post',
      data
  })
};
// 7.8.称重列表查询
export const getMeterWeightPage = data => {
  return axios({
      url: '/api/sys/meter/weight/getMeterWeightPage',
      method: 'post',
      data
  })
};
// 7.8.称重列表明细
export const getMeterWeightDetailPage = data => {
  return axios({
      url: '/api/sys/meter/weight/getMeterWeightDetailPage',
      method: 'post',
      data
  })
};
// 上传
export const uploadMeterWayCar = data => {
  return axios({
      url: '/api/sys/meter/meterWayCar/uploadMeterWayCar',
      method: 'post',
      data
  })
};
// 11.导出
export const exportMeterWayCarList = data => {
  return axios({
      url: '/api/sys/meter/meterWayCar/exportMeterWayCarList',
      method: 'post',
      data
  })
};
// 11.导出
export const exportMeterWeightList = data => {
  return axios({
      url: '/api/sys/meter/weight/exportMeterWeightList',
      method: 'post',
      data
  })
};
// 11.导出
export const getMeterWayCarLog = data => {
  return axios({
      url: '/api/sys/meter/meterWayCar/getMeterWayCarLog',
      method: 'post',
      data
  })
};
// 皮带秤
export const getMeterBeltPage = data => {
  return axios({
      url: '/api/sys/meter/getMeterBeltPage',
      method: 'post',
      data
  })
};
// 13.车辆进出厂记录
export const getMeterAccessLogPage = data => {
  return axios({
      url: '/api/sys/meter/getMeterAccessLogPage',
      method: 'post',
      data
  })
};
// 车辆进出厂记录 新增
export const enterFactory = data => {
  return axios({
      url: '/api/sys/meter/enterFactory',
      method: 'post',
      data
  })
};
// 车辆进出厂记录 3.修改
export const exFactory = data => {
  return axios({
      url: '/api/sys/meter/exFactory',
      method: 'post',
      data
  })
};
// 车辆进出厂记录 3.删除
export const deleteMeterAccessLogs = data => {
  return axios({
      url: '/api/sys/meter/deleteMeterAccessLogs',
      method: 'post',
      data
  })
};
// 删除称重表
export const deleteMeterWeights = data => {
  return axios({
      url: '/api/sys/meter/weight/deleteMeterWeights',
      method: 'post',
      data
  })
};
// 修改称重表
export const updateMeterWeight = data => {
  return axios({
      url: '/api/sys/meter/weight/updateMeterWeight',
      method: 'post',
      data
  })
};

// 车辆进出厂记录导出
export const exportMeterAccessLogList = data => {
  return axios({
      url: '/api/sys/meter/exportMeterAccessLogList',
      method: 'post',
      data
  })
};
// 车辆出厂
export const factory = data => {
  return axios({
      url: '/api/sys/meter/meterWayCar/factory',
      method: 'post',
      data
  })
};
// 扣重审批
export const deductAudit = data => {
  return axios({
      url: '/api/sys/meter/meterWayCar/deductAudit',
      method: 'post',
      data
  })
};
// 扣重审批
export const getLargeScreenList = data => {
  return axios({
      url: '/api/sys/meter/meterWayCar/getLargeScreenList',
      method: 'post',
      data
  })
};

export const updateShipNo = data => {
  return axios({
      url: '/api/sys/meter/meterWayCar/updateShipNo',
      method: 'post',
      data
  })
};
// 计量磅码单列表
export const getMeterWeightRecordPage = data => {
  return axios({
      url: '/api/sys/meter/weight/record/getMeterWeightRecordPage',
      method: 'post',
      data
  })
};
// 保存计量磅码单
export const saveMeterWeightRecord = data => {
  return axios({
      url: '/api/sys/meter/weight/record/saveMeterWeightRecord',
      method: 'post',
      data
  })
};
// 查询当前时间的班次
export const getMeterClassTime = data => {
  return axios({
      url: '/api/sys/meter/class/getMeterClassTime',
      method: 'post',
      data
  })
};
// 最后一次计量磅码单(批量)
export const getMeterWeightRecordByCarTareList = data => {
  return axios({
      url: '/api/sys/meter/weight/record/getMeterWeightRecordByCarTareList',
      method: 'post',
      data
  })
};
// 批量保存计量磅码单
export const batchSaveMeterWeightRecord = data => {
  return axios({
      url: '/api/sys/meter/weight/record/batchSaveMeterWeightRecord',
      method: 'post',
      data
  })
};
// 读取卡号
export const readCardIotDevice = data => {
  return axios({
      url: '/api/sys/iot/device/readCardIotDevice',
      method: 'post',
      data
  })
};
// 读取车号
export const plateNumberIotDevice = data => {
  return axios({
      url: '/api/sys/iot/device/plateNumberIotDevice',
      method: 'post',
      data
  })
};
// 读取车号
export const weightIotDevice = data => {
  return axios({
      url: '/api/sys/iot/device/weightIotDevice',
      method: 'post',
      data
  })
};
// 读取车号
export const leaveFactory = data => {
  return axios({
      url: '/api/sys/meter/leaveFactory',
      method: 'post',
      data
  })
};
// 刷卡过磅
export const saveIdicWeight = data => {
  return axios({
      url: '/api/sys/meter/weight/saveIdicWeight',
      method: 'post',
      data
  })
};
// 刷卡登记信息
export const getIdicWeight = data => {
  return axios({
      url: '/api/sys/meter/weight/getIdicWeight',
      method: 'post',
      data
  })
};
// 补打
export const printMeterAccessLogMtr = data => {
  return axios({
      url: '/api/sys/meter/printMeterAccessLogMtr',
      method: 'post',
      data
  })
};
// 称重记录修改
export const updateMeterWeightWeb = data => {
  return axios({
      url: '/api/sys/meter/weight/updateMeterWeightWeb',
      method: 'post',
      data
  })
};
// 一次已称重修改过磅单物料、司机
export const modifyMeterWeightMaterial = data => {
  return axios({
      url: '/api/sys/meter/weight/modifyMeterWeightMaterial',
      method: 'post',
      data
  })
};
// 一次已称重修改车号
export const modifyMeterWayCar = data => {
  return axios({
      url: '/api/sys/meter/meterWayCar/modifyMeterWayCar',
      method: 'post',
      data
  })
};
// 二次已称重修改车号
export const modifyMeterWayCarSecond = data => {
  return axios({
      url: '/api/sys/meter/meterWayCar/modifyMeterWayCarSecond',
      method: 'post',
      data
  })
};
// 计量配置信息列表(二次重自动打印)
export const getMeterConfigPage = data => {
  return axios({
      url: '/api/sys/meter/config/getMeterConfigPage',
      method: 'post',
      data
  })
};
// 过磅单复磅
export const weighingAgain = data => {
  return axios({
      url: '/api/sys/meter/weight/weighingAgain',
      method: 'post',
      data
  })
};
// 入场车辆排队过磅
export const getVehicleQueueWeighingList = data => {
  return axios({
      url: '/api/sys/meter/meterWayCar/getVehicleQueueWeighingList',
      method: 'post',
      data
  })
};


// 根据id数组查询移库车辆信息物料比例表
export const getStkIwcProportionListByIds = data => {
  return axios({
      url: '/api/sys/stk/iwc/proportion/getStkIwcProportionListByIds',
      method: 'post',
      data
  })
}

//过磅单明细查询
export const getAssociationMeterWeightList = data => {
  return axios({
      url: '/api/sys/meter/weight/getAssociationMeterWeightList',
      method: 'post',
      data
  })
}



// WEBPACK FOOTER //
// ./src/api/moudules/Car.js